// extracted by mini-css-extract-plugin
export default {"dateSwitch":"DateSwitch_dateSwitch__b7Znk","datePickerArea":"DateSwitch_datePickerArea__A8J5j","switchBtn":"DateSwitch_switchBtn__UvNUh","label":"DateSwitch_label__0gGNp"};